import { useEffect, useRef } from "react";
import { drawControlChart } from "@/lib/incomingInspectionSpc";

/** Thin canvas wrapper around drawControlChart() — redraws whenever the
 *  series (points/ucl/lcl/cl/flags) changes. */
export default function ControlChart({ title, points, ucl, lcl, cl, flags, height = 260 }) {
  const canvasRef = useRef(null);

  useEffect(() => {
    if (!canvasRef.current || !points || points.length === 0) return;
    drawControlChart(canvasRef.current, { points, ucl, lcl, cl, flags });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(points), ucl, lcl, cl, JSON.stringify(flags)]);

  return (
    <div className="mt-4">
      <h3 className="text-sm font-semibold text-slate-700 mb-2">{title}</h3>
      <div className="bg-white border border-slate-200 rounded-lg p-2 overflow-x-auto">
        <canvas ref={canvasRef} width={1000} height={height} className="w-full" style={{ minWidth: 640 }} />
      </div>
    </div>
  );
}
